import React from "react";
import "./App.css";
import Landing from "./features/landing/Landing";
import OurApproach from "./features/our-approach/OurApproach";
import WhyGeesez from "./features/why-geesez/WhyGeesez";
import ContactUs from "./features/contact-us/ContactUs";
import Footer from "./components/footer/Footer";

function App() {
  return (
    <div className="App bg-theme-secondary">
      <Landing />
      <div id="our-approach">
        <OurApproach />
      </div>
      <div id="why-geesez">
        <WhyGeesez />
      </div>
      <div id="contact">
        <ContactUs />
      </div>
      <Footer />
    </div>
  );
}

export default App;
